import React from 'react';
import { useTranslation } from 'react-i18next';
import { Waves, Dumbbell, UtensilsCrossed, Baby } from 'lucide-react';

const AmenitiesSection = () => {
  const { t } = useTranslation();
  
  const amenities = [
    {
      icon: <Waves className="w-8 h-8" />,
      title: t('amenities.items.pool.title'),
      description: t('amenities.items.pool.description')
    },
    {
      icon: <Dumbbell className="w-8 h-8" />,
      title: t('amenities.items.gym.title'),
      description: t('amenities.items.gym.description')
    },
    {
      icon: <UtensilsCrossed className="w-8 h-8" />,
      title: t('amenities.items.bbq.title'),
      description: t('amenities.items.bbq.description')
    },
    {
      icon: <Baby className="w-8 h-8" />,
      title: t('amenities.items.playground.title'),
      description: t('amenities.items.playground.description')
    }
  ];

  return (
    <section id="amenities" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003366] mb-4">
            {t('amenities.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('amenities.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          {amenities.map((amenity, index) => (
            <div
              key={index}
              className="flex items-start gap-6 p-6 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow border-l-4 border-[#0052CC]"
            >
              <div className="flex-shrink-0 w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center text-[#0052CC]">
                {amenity.icon}
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{amenity.title}</h3>
                <p className="text-gray-600">{amenity.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;